export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/dd310f1c73ee98664ba9acf92580b449.png";